import { render } from "./svgPack.vue?vue&type=template&id=b75061f6"
const script = {}

import "./svgPack.vue?vue&type=style&index=0&id=b75061f6&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__